<template>
  <div>
    <el-dialog
      title="新增角色"
      :visible.sync="roleVisible"
      :before-close="handleCancel"
    >
      <div>
        <el-form
          ref="form"
          :model="form"
          label-width="90px"
        >
          <el-form-item label="角色名称">
            <el-col :span="14">
              <el-input
                v-model="form.role_name"
                :maxlength="20"
                placeholder="订单管理员、商品管理员、等等"
              />
            </el-col>
          </el-form-item>
          <el-form-item label="角色权限">
            <Tree
              ref="Trees"
              :row-data="row"
              :tree-checked-keys="defaultCheckedKeys"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="handleCancel">
          取 消
        </el-button>
        <el-button
          type="primary"
          @click="submitRoleAction"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { filterHideMenu } from '@/utils'
import { mapGetters } from 'vuex'
import Tree from './tree'
export default {
  components: {
    Tree: Tree
  },
  model: {
    prop: 'roleVisible',
    event: 'roleVisibleChange'
  },
  props: {
    data: Array,
    aType: String,
    roleVisible: Boolean
  },
  data () {
    return {
      defaultCheckedKeys: [],
      form: {
        role_name: '',
        role_id: '',
        permission: []
      }
    }
  },
  computed: {
    id () {
      return this.data && this.data[0] && this.data[0].id
    },
    row () {
      return this.data && this.data[0]
    },
    ...mapGetters(['menus'])
  },
  watch: {
    info: {
      immediate: true,
      handler (val) {}
    },
    form: {
      deep: true,
      handler (nv, ov) {
        console.log('form', nv, ov)
      }
    }
  },
  mounted () {},
  created () {
    console.log('this.menus', this.menus)
  },
  methods: {
    filterHideMenu: filterHideMenu,
    handleCancel () {
      this.$emit('refresh')
      this.$emit('roleVisibleChange', false)
      // this.$refs.tree.setCheckedKeys([])
    },
    submitRoleAction () {
      // 提交物料
      const self = this
      this.form.permission = this.$refs.Trees.getTreeData()
      if (this.form.role_name == 0)
        return this.$message.error({
          message: '请输入角色名',
          type: 'success'
        })
      if ((this.form.permission && this.form.permission.length == 0) || !this.form.permission)
        return this.$message.error({
          message: '请选择角色权限',
          type: 'success'
        })
      if (this.form.role_id) {
        self.$api['setting/roleSetting']
          .updateRolesInfo(this.form.role_id, this.form)
          .then((response) => {
            this.handleCancel()
          })
      } else {
        self.$api['setting/roleSetting'].createRoles(this.form).then((response) => {
          this.handleCancel()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.select-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0;
}
.select-footer {
  padding: 20px 0;
}
.nodata {
  padding: 30px;
  text-align: center;
  color: #666666;
}
.guize-list {
  li {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #f1f1f1;
    padding: 5px 0;
    .avatar-box {
      width: 50px;
    }
    .btn-box {
      width: 86px;
      text-align: center;
    }
    .item {
      flex: 1;
      font-size: 12px;
      .title {
        color: #333;
      }
      .content {
        color: #666666;
        .name {
          color: #333;
          display: inline-block;
          padding: 10px;
        }
      }
    }
  }
}
</style>
